
import { defineComponent } from 'vue';
import { ModalContentWrapper } from './components';
import { ModalProps } from './props';

export default defineComponent({
  components: {
    ModalContentWrapper,
  },
  props: ModalProps,
  emits: [
    /** v-model */
    'update:visible',
    /** 点击取消 */
    'cancel',
    /** 点击确定 */
    'ok',
  ],
});
